import React from 'react';
import Layout from '../../components/Layout';
import GeneralLedger from '../../components/GeneralLedger';

const GeneralLedgerPage = () => (
  <Layout pageTitle="General Ledger">
    <GeneralLedger />
  </Layout>
);

export default GeneralLedgerPage;
